import { Box, Flex, type FlexboxProps, Grid } from "@chakra-ui/react"
import type { ReactNode } from "react"

import ConfidentialLines from "../ConfidentialLines"
import FormLabelRequired from "../FormLabel/FormLabelRequired"
import FieldLabel from "./FieldLabel"
import FieldLabelSmall from "./FieldLabelSmall"
import type { SharedFieldProps } from "./types"

type Props = React.PropsWithChildren<
  {
    label: ReactNode | string
    required?: boolean
    gap?: string
    gridTemplateColumns?: string
    width?: string
  } & SharedFieldProps &
    FlexboxProps
>

type PropsColumn = React.PropsWithChildren<
  {
    label: ReactNode | string
    required?: boolean
    gap?: string
  } & FlexboxProps
>

export function MultipleFieldColumn({ label, required, children, gap }: PropsColumn) {
  return (
    <Flex flexDir="column" flexGrow={1} gap={gap ?? "2"} width="stretch">
      <FieldLabelSmall py={2}>
        {label}
        {required && <FormLabelRequired />}
      </FieldLabelSmall>
      <Box>{children}</Box>
    </Flex>
  )
}

export function MultipleField({
  label,
  required,
  children,
  isConfidential,
  alignItems,
  gridTemplateColumns,
  gap,
  width,
  flexDir,
}: Props) {
  return (
    <Grid
      gap={gap ?? "6"}
      gridTemplateColumns={gridTemplateColumns ?? "160px 1fr"}
      alignItems={alignItems ?? "start"}
      width={width ?? "100%"}
    >
      <FieldLabel pt="calc(2.25rem + 20px)" disabled={isConfidential}>
        {label}
        {required && <FormLabelRequired />}
      </FieldLabel>
      {isConfidential ? (
        <ConfidentialLines py={2} />
      ) : (
        <Flex
          py={2}
          alignSelf="start"
          alignItems="stretch"
          flexShrink={0}
          flexGrow={1}
          flexDir={flexDir ?? "row"}
          gap={gap ?? "6"}
        >
          {children}
        </Flex>
      )}
    </Grid>
  )
}
